import { Input } from "@/components/ui/input";
import { money } from "@/components/finance/fin";

/** Hours × hourly rate entry for overtime, paid duty, court and callback lines. */
export function HoursCalc({ line, rates, onChange }) {
  const c = line.calc;
  const opts = rates?.[line.category] || [];
  const set = (patch) => onChange({ ...line, calc: { ...c, ...patch } });
  const known = opts.find((o) => Number(o.rate) === Number(c.rate));
  const amount = (Number(c.hours) || 0) * (Number(c.rate) || 0);
  return (
    <div className="flex flex-wrap gap-2 items-center" data-testid={`budget-hours-${line.id}`}>
      <Input type="number" step="0.25" min="0" placeholder="Hours" value={c.hours} data-testid={`budget-hours-input-${line.id}`}
        onChange={(e) => set({ hours: e.target.value })} className="h-9 w-24 bg-secondary/40" />
      {opts.length > 0 ? (
        <select value={known ? String(known.rate) : "custom"} data-testid={`budget-rate-select-${line.id}`}
          onChange={(e) => { const o = opts.find((x) => String(x.rate) === e.target.value); set(o ? { rate: o.rate, rate_label: o.label } : { rate: "", rate_label: "Custom rate" }); }}
          className="h-9 flex-1 min-w-[200px] rounded-md border border-input bg-secondary/40 px-2 text-sm">
          {opts.map((o) => <option key={o.rate} value={String(o.rate)}>{o.label}</option>)}
          <option value="custom">Custom rate…</option>
        </select>
      ) : null}
      {(!known || !opts.length) && (
        <Input type="number" step="0.01" min="0" placeholder="Rate $/h" value={c.rate} data-testid={`budget-rate-input-${line.id}`}
          onChange={(e) => set({ rate: e.target.value, rate_label: "Custom rate" })} className="h-9 w-28 bg-secondary/40" />
      )}
      <p className="text-sm font-bold ml-auto tabular-nums" data-testid={`budget-hours-total-${line.id}`}>= {money(amount)}</p>
    </div>
  );
}
